import { render, staticRenderFns } from "./AssignmentTrip.vue?vue&type=template&id=1427241d&scoped=true&"
import script from "./AssignmentTrip.vue?vue&type=script&lang=js&"
export * from "./AssignmentTrip.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTrip.vue?vue&type=style&index=0&id=1427241d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427241d",
  null
  
)

export default component.exports